import React from 'react';
import PropTypes from 'prop-types';

import { OSLO_GRAY } from '@constant/colors';

const Padlock = ({ className, color }) => (
  <svg className={className} viewBox="731 547 9 11">
    <path
      d="M738,551 L738,549.5093 C738,548.112366 736.880712,547 735.5,547 C734.109662,547 733,548.123452 733,549.5093 L733,551 L731.997545,551 C731.446311,551 731,551.449027 731,552.002929 L731,556.997071 C731,557.562119 731.446616,558 731.997545,558 L739.002455,558 C739.553689,558 740,557.550973 740,556.997071 L740,552.002929 C740,551.437881 739.553384,551 739.002455,551 L738,551 Z M734,551 L734,549.506398 C734,548.674437 734.665797,548 735.5,548 C736.328427,548 737,548.676463 737,549.506398 L737,551 L734,551 Z"
      stroke="none"
      fill={color}
      fillRule="evenodd"
    />
  </svg>
);

Padlock.propTypes = {
  className: PropTypes.string,
  color: PropTypes.string,
};

Padlock.defaultProps = {
  color: OSLO_GRAY,
};

export default Padlock;
